import React, { JSX } from 'react';

import { PageLayout } from '../lib';

const NotAvailable = (): JSX.Element => (
  <PageLayout className={'p-3'}>
    <h1>50x</h1>
    <h3>We are very sorry, the system is currently not available. Please try again later.</h3>
  </PageLayout>
);

export default NotAvailable;
